{
  "INBOX_MGMT": {
    "HEADER": "Κιβώτια Εισερχομένων",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Επανασύνδεση",
      "FACEBOOK": "Η σύνδεση με το Facebook έληξε ή ανακλήθηκε. Τα μηνύματα προς τη σελίδα δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Ένα άτομο που διαχειρίζεται τη σελίδα Facebook πρέπει να κάνει κλικ στην Επανασύνδεση και να συνδεθεί στο Facebook.",
      "INSTAGRAM": "Η σύνδεση με το Instagram έληξε ή ανακλήθηκε. Τα μηνύματα προς τον λογαριασμό δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Κάντε κλικ στην Επανασύνδεση και συνδεθείτε στον ίδιο λογαριασμό Instagram. Ένας άλλος λογαριασμός δημιουργεί νέα εισερχόμενα.",
      "GOOGLE": "Η σύνδεση με τη Google έληξε ή ανακλήθηκε. Τα νέα email δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Κάντε κλικ στην Επανασύνδεση και συνδεθείτε στη Google ως {email}.",
      "MICROSOFT": "Η σύνδεση με τη Microsoft έληξε ή ανακλήθηκε. Τα νέα email δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Κάντε κλικ στην Επανασύνδεση και συνδεθείτε στη Microsoft ως {email}.",
      "ALLEGRO": "Η σύνδεση με το Allegro έληξε ή ανακλήθηκε. Τα μηνύματα των αγοραστών δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Κάντε κλικ στην Επανασύνδεση και συνδεθείτε στο Allegro ως ο πωλητής {seller}. Ένας άλλος λογαριασμός πωλητή δημιουργεί νέα εισερχόμενα.",
      "IMAP_LOGIN": "Ο διακομιστής αλληλογραφίας απορρίπτει τη σύνδεση IMAP {login}. Τα νέα email δεν φτάνουν σε αυτό το εισερχόμενο. Ελέγξτε το όνομα χρήστη και τον κωδικό IMAP στην καρτέλα {tab} και αποθηκεύστε τα. Συνεχίζουμε να προσπαθούμε να συνδεθούμε και το εισερχόμενο αποκαθίσταται μόλις η σύνδεση λειτουργήσει.",
      "WHATSAPP": "Η σύνδεση με το WhatsApp έληξε ή ανακλήθηκε. Τα συνημμένα από πελάτες δεν φτάνουν σε αυτά τα εισερχόμενα και οι απαντήσεις μπορεί να αποτύχουν. Κάντε κλικ στο Επανασύνδεση, συνδεθείτε στο Facebook και επιλέξτε ξανά τον αριθμό {phone}."
    },
    "LIST": {
      "404": "Δεν υπάρχουν κιβώτια εισερχομένων σε αυτόν τον λογαριασμό.",
      "RECONNECT_REQUIRED": "Απαιτείται επανασύνδεση"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Επιλογή Καναλιού",
        "BODY": "Επίλεξετε το κανάλι που θέλετε να ενσωματώσετε στο chat."
      },
      "INBOX": {
        "TITLE": "Δημιουργία Κιβωτίου",
        "BODY": "Πιστοποιήστε τον λογαριασμό σας και δημιουργείστε κιβώτιο Εισερχομένων."
      },
      "AGENT": {
        "TITLE": "Προσθήκη Πρακτόρων",
        "BODY": "Προσθέστε πράκτορες στο κιβώτιο που δημιουργήθηκε."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Είσαστε έτοιμοι να ξεκινήσετε!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Όνομα Κιβωτίου",
        "PLACEHOLDER": "Συμπληρώστε την ονομασία του κιβωτίου σας (π. χ: Ελληνικό Μεσογειακό Πανεπιστήμιο)",
        "ERROR": "Παρακαλώ εισάγετε έγκυρο όνομα εισερχόμενων"
      },
      "WEBSITE_NAME": {
        "LABEL": "Όνομα Ιστοσελίδας",
        "PLACEHOLDER": "Συμπληρώστε την ονομασία της ιστοσελίδας σας (π.χ: Ελληνικό Μεσογειακό Πανεπιστήμιο)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Εσωτερικό Όνομα",
        "PLACEHOLDER": "Ονομάστε το κιβώτιο όπως εμφανίζεται σε αυτό το ταμπλό",
        "ERROR": "Παρακαλώ εισάγετε ένα μοναδικό εσωτερικό όνομα"
      },
      "FB": {
        "HELP": "ΥΓ: Με την είσοδο, θα έχουμε πρόσβαση μόνο στα μηνύματα της σελίδας σας. Δεν θα έχουμε ποτέ πρόσβαση στα ιδιωτικά μηνύματά σας.",
        "CHOOSE_PAGE": "Διάλεξε Σελίδα",
        "CHOOSE_PLACEHOLDER": "Επιλέξτε σελίδα από την Λίστα",
        "INBOX_NAME": "Όνομα Κιβωτίου",
        "ADD_NAME": "Ονοματίστε το κιβώτιο σας",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Επιλέξτε τιμή",
        "CREATE_INBOX": "Δημιουργία Κιβωτίου"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Συνέχεια με Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Συνδέστε το Προφίλ σας στο Instagram",
        "HELP": "Για να προσθέσετε το προφίλ σας στο Instagram ως κανάλι, πρέπει να επικυρώσετε το προφίλ σας στο Instagram κάνοντας κλικ στο 'Συνέχεια με Instagram' ",
        "ERROR_MESSAGE": "Παρουσιάστηκε σφάλμα σύνδεσης στο Instagram, παρακαλώ προσπαθήστε ξανά",
        "ERROR_AUTH": "Παρουσιάστηκε σφάλμα σύνδεσης στο Instagram, παρακαλώ προσπαθήστε ξανά",
        "NEW_INBOX_SUGGESTION": "Αυτός ο λογαριασμός Instagram ήταν προηγουμένως συνδεδεμένος με διαφορετικό κιβώτιο και έχει πλέον μεταφερθεί εδώ. Όλα τα νέα μηνύματα θα εμφανίζονται εδώ. Το παλιό κιβώτιο δεν θα μπορεί πλέον να στέλνει ή να λαμβάνει μηνύματα για αυτόν τον λογαριασμό.",
        "DUPLICATE_INBOX_BANNER": "Αυτός ο λογαριασμός Instagram μεταφέρθηκε στο νέο κιβώτιο καναλιού Instagram. Δεν θα μπορείτε πλέον να στέλνετε/λαμβάνετε μηνύματα Instagram από αυτό το κιβώτιο."
      },
      "TWITTER": {
        "HELP": "Για να προσθέσετε το Προφίλ Twitter ως κανάλι, πρέπει να επικυρώστε το Προφίλ σας στο Twiter κάνοντας click στο 'Είσοδος με το Twitter' ",
        "ERROR_MESSAGE": "Παρουσιάστηκε σφάλμα σύνδεσης στο Twitter, παρακαλώ προσπαθήστε ξανά",
        "TWEETS": {
          "ENABLE": "Δημιουργία συνομιλιών από τα αναφερόμενα Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Κανάλι Ιστοσελίδας",
        "DESC": "Δημιουργήστε ένα κανάλι Ιστοσελίδα για να υποστηρίξετε τους πελάτες σας μέσω του πρόσθετου επικοινωνίας (widget) που θα εγκαταστήσετε στην ιστοσελίδα σας.",
        "LOADING_MESSAGE": "Δημιουργία κανάλιού υποστήριξης ιστοσελίδας",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar Καναλιού"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Σύνδεσμος Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Παρακαλώ εισάγετε ένα έγκυρο URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domain Ιστοσελίδας",
          "PLACEHOLDER": "Συμπληρώστε το domain της Ιστοσελίδας σας (π.χ: hmu.gr)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Καλώς ήλθατε (Heading)",
          "PLACEHOLDER": "Γεια χαρά !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Καλώς ήλθατε (Tagline)",
          "PLACEHOLDER": "Είναι απλό να συνδεθείτε μαζί μας. Ζητήστε μας οτιδήποτε, ή μοιραστείτε την εμπειρία σας."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Μήνυμα καλωσορίσματος στο Κανάλι",
          "PLACEHOLDER": "Τυπικά απαντάμε σε μερικές ώρες."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Ενεργοποίηση καλωσορίσματος",
          "HELP_TEXT": "Αυτόματη αποστολή χαιρετισμού όταν δημιουργείται μια νέα συνομιλία.",
          "ENABLED": "Ενεργό",
          "DISABLED": "Ανενεργό"
        },
        "REPLY_TIME": {
          "TITLE": "Ορισμός Χρόνου Απάντησης",
          "IN_A_FEW_MINUTES": "Σε μερικά λεπτά",
          "IN_A_FEW_HOURS": "Σε μερικές ώρες",
          "IN_A_DAY": "Σε μία ημέρα",
          "HELP_TEXT": "Ο χρόνος απάντησης θα εμφανίζεται στο widget συνομιλίας"
        },
        "WIDGET_COLOR": {
          "LABEL": "Χρώμα Widget",
          "PLACEHOLDER": "Ενημερώστε το χρώμα του 'widget' που θα εμφανίζεται στους χρήστες"
        },
        "SUBMIT_BUTTON": "Δημιουργία Κιβωτίου",
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να δημιουργήσουμε κανάλι ιστοσελίδας, παρακαλώ προσπαθήστε ξανά"
        }
      },
      "TWILIO": {
        "TITLE": "Κανάλι Twilio SMS/Whatsapp",
        "DESC": "Ενσωματώστε το Twilio και αρχίστε να υποστηρίζετε τους πελάτες σας μέσω SMS.",
        "ACCOUNT_SID": {
          "LABEL": "SID Λογαριασμού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε το SID του Λογαριασμού Twilio",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID Υπηρεσίας Μηνυμάτων",
          "PLACEHOLDER": "Παρακαλώ εισάγετε το Twilio Messaging Service SID σας",
          "ERROR": "Το πεδίο είναι απαραίτητο",
          "USE_MESSAGING_SERVICE": "Χρήση μιας υπηρεσίας μηνυμάτων Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Τύπος Καναλιού",
          "ERROR": "Παρακαλώ επιλέξετε τον τύπο Καναλιού"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Παρακαλώ εισάγετε τον Twilio Auth Token",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "CHANNEL_NAME": {
          "LABEL": "Όνομα Κιβωτίου",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα εισερχόμενων",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "PHONE_NUMBER": {
          "LABEL": "Αριθμός Τηλεφώνου",
          "PLACEHOLDER": "Παρακαλώ εισάγετε έναν αριθμό τηλεφώνου από τον οποίο θα σταλεί το μήνυμα.",
          "ERROR": "Παρακαλώ δώστε έναν έγκυρο αριθμό τηλεφώνου που ξεκινά με ένα σύμβολο `+` και δεν περιέχει κενά."
        },
        "API_CALLBACK": {
          "TITLE": "URL επανάκλησης",
          "SUBTITLE": "Πρέπει να ρυθμίσετε το callback URL στο Twilio με το URL που αναφέρεται εδώ."
        },
        "SUBMIT_BUTTON": "Δημιουργία Καναλιού Twilio",
        "API": {
          "ERROR_MESSAGE": "Δεν ήταν δυνατή η πιστοποίηση των διαπιστευτηρίων Twilio. Δοκιμάστε ξανά"
        }
      },
      "SMS": {
        "TITLE": "Κανάλι SMS",
        "DESC": "Ξεκινήστε να υποστηρίζετε τους πελάτες σας μέσω SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Εύρος Ζώνης",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να αποθηκεύσουμε το κανάλι SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID Λογαριασμού",
            "PLACEHOLDER": "Παρακαλώ εισάγετε το ID του Λογαριασμού σας Bandwidth",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "API_KEY": {
            "LABEL": "Κλειδί API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "APPLICATION_ID": {
            "LABEL": "ID Εφαρμογής",
            "PLACEHOLDER": "Παρακαλώ εισάγετε το ID του Λογαριασμού σας Bandwidth",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "INBOX_NAME": {
            "LABEL": "Όνομα Κιβωτίου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα εισερχόμενων",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "PHONE_NUMBER": {
            "LABEL": "Αριθμός τηλεφώνου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε έναν αριθμό τηλεφώνου από τον οποίο θα σταλεί το μήνυμα.",
            "ERROR": "Παρακαλώ δώστε έναν έγκυρο αριθμό τηλεφώνου που ξεκινά με ένα σύμβολο `+` και δεν περιέχει κενά."
          },
          "SUBMIT_BUTTON": "Δημιουργήστε Bandwidth",
          "API": {
            "ERROR_MESSAGE": "Δεν ήταν δυνατή η πιστοποίηση των διαπιστευτηρίων Bandwidth. Δοκιμάστε ξανά"
          },
          "API_CALLBACK": {
            "TITLE": "URL επανάκλησης",
            "SUBTITLE": "Πρέπει να ρυθμίσετε το callback URL στο Bandwidth με το URL που αναφέρεται εδώ."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Όνομα Κιβωτίου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα εισερχόμενων",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "PHONE_NUMBER": {
            "LABEL": "Αριθμός τηλεφώνου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε τον αριθμό τηλεφώνου από τον οποίο θα σταλούν τα μηνύματα.",
            "ERROR": "Παρακαλώ δώστε έναν έγκυρο αριθμό τηλεφώνου που ξεκινά με το σύμβολο `+`."
          },
          "SUBMIT_BUTTON": "Δημιουργία Καναλιού SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να δημιουργήσουμε το κανάλι SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Όνομα Κιβωτίου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα εισερχόμενων",
            "ERROR": "Το πεδίο είναι απαραίτητο"
          },
          "PHONE_NUMBER": {
            "LABEL": "Αριθμός τηλεφώνου",
            "PLACEHOLDER": "Παρακαλώ εισάγετε τον αριθμό τηλεφώνου από τον οποίο θα σταλούν τα μηνύματα.",
            "ERROR": "Παρακαλώ δώστε έναν έγκυρο αριθμό τηλεφώνου που ξεκινά με το σύμβολο `+`."
          },
          "SUBMIT_BUTTON": "Δημιουργία Καναλιού DIDWW",
          "API": {
            "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να δημιουργήσουμε το κανάλι DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Πρέπει να ρυθμίσετε τη διεύθυνση URL του webhook και το διακριτικό επαλήθευσης στην πύλη Προγραμματιστή Facebook με τις τιμές που εμφανίζονται παρακάτω.",
          "WEBHOOK_URL": "Σύνδεσμος Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token Επαλήθευσης Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Γρήγορη Ρύθμιση με το Meta",
          "DESC": "Θα ανακατευθυνθείτε στο Meta για να συνδεθείτε στον λογαριασμό σας WhatsApp Business. Η πρόσβαση διαχειριστή θα κάνει τη ρύθμιση πιο εύκολη και ομαλή.",
          "BENEFITS": {
            "EASY_SETUP": "Δεν απαιτείται χειροκίνητη διαμόρφωση",
            "SECURE_AUTH": "Ασφαλής ταυτοποίηση βασισμένη σε OAuth",
            "AUTO_CONFIG": "Αυτόματη διαμόρφωση webhook και αριθμού τηλεφώνου"
          },
          "SUBMIT_BUTTON": "Σύνδεση με WhatsApp Business",
          "AUTH_PROCESSING": "Ταυτοποίηση με το Meta",
          "WAITING_FOR_BUSINESS_INFO": "Παρακαλώ ολοκληρώστε τη ρύθμιση επιχείρησης στο παράθυρο του Meta...",
          "PROCESSING": "Ρύθμιση του λογαριασμού σας WhatsApp Business",
          "CANCELLED": "Η εγγραφή WhatsApp ακυρώθηκε",
          "WAITING_FOR_AUTH": "Αναμονή ταυτοποίησης...",
          "INVALID_BUSINESS_DATA": "Λήφθηκαν μη έγκυρα δεδομένα επιχείρησης από το Facebook. Παρακαλώ προσπαθήστε ξανά.",
          "SIGNUP_ERROR": "Παρουσιάστηκε σφάλμα εγγραφής",
          "SDK_LOAD_ERROR": "Δεν ήταν δυνατή η φόρτωση του Facebook SDK. Δοκιμάστε ξανά.",
          "AUTH_NOT_COMPLETED": "Η ταυτοποίηση δεν ολοκληρώθηκε. Παρακαλώ ξεκινήστε ξανά τη διαδικασία.",
          "SUCCESS_FALLBACK": "Ο λογαριασμός WhatsApp Business διαμορφώθηκε με επιτυχία",
          "RECONNECTED": "Το κανάλι WhatsApp συνδέθηκε ξανά με επιτυχία"
        },
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να αποθηκεύσουμε το κανάλι WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Κανάλι API",
        "DESC": "Ενσωματώστε ένα κανάλι APΙ και ξεκινήσετε την υποστήριξη των πελατών σας.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα καναλιού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα καναλιού",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "WEBHOOK_URL": {
          "LABEL": "Σύνδεσμος Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Σύνδεσμος Webhook"
        },
        "SUBMIT_BUTTON": "Δημιουργία API Καναλιού",
        "API": {
          "ERROR_MESSAGE": "Δεν είμαστε σε θέση να αποθηκεύσουμε το API κανάλι"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Κανάλι Salesforce",
        "DESC": "Ενσωματώστε το κανάλι Salesforce και ξεκινήστε να υποστηρίζετε τους πελάτες σας.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα Καναλιού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα καναλιού",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Διαμορφώστε το βασικό URL για το στιγμιότυπο (instance) Salesforce σας.",
          "PLACEHOLDER": "URL Salesforce API"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Το Key ID για το κανάλι Salesforce σας.",
          "PLACEHOLDER": "KEY ID"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Το Secret για το κανάλι Salesforce σας.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Δημιουργία Καναλιού Salesforce",
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να αποθηκεύσουμε το κανάλι Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "Σύνδεσμος Webhook",
          "SUBTITLE": "Πρέπει να ρυθμίσετε το webhook URL στο Salesforce με το URL που αναφέρεται εδώ."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Χρησιμοποιήστε αυτό το bearer token για ταυτοποίηση κατά τη διαμόρφωση του webhook στο Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Αντικατάσταση Αποστολέα Email",
          "SUBTITLE": "Αν οριστεί, αυτή η διεύθυνση email θα χρησιμοποιείται ως αποστολέας για όλα τα εξερχόμενα email αντί για το email προέλευσης της συνομιλίας.",
          "PLACEHOLDER": "π.χ. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Κανάλι Allegro",
        "DESC": "Συνδέστε έναν λογαριασμό πωλητή Allegro και απαντήστε στα μηνύματά του από το Κέντρο Επικοινωνίας.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα Κιβωτίου",
          "SUBTITLE": "Το όνομα που βλέπουν οι πράκτορες για αυτό το κιβώτιο.",
          "PLACEHOLDER": "Εισάγετε ένα όνομα κιβωτίου",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "SUBMIT_BUTTON": "Σύνδεση με Allegro",
        "API": {
          "ERROR_MESSAGE": "Παρουσιάστηκε σφάλμα σύνδεσης στο Allegro, παρακαλώ προσπαθήστε ξανά"
        },
        "SELLER_LOGIN": {
          "TITLE": "Σύνδεση Allegro",
          "SUBTITLE": "Ο λογαριασμός πωλητή του οποίου τα μηνύματα διαβάζει και απαντά αυτό το κιβώτιο."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Κανάλι Kaufland",
        "DESC": "Απαντήστε στα μηνύματα αιτημάτων που σας στέλνουν οι αγοραστές στην αγορά Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα καναλιού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα καναλιού",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Το Client Key των 32 χαρακτήρων από τη σελίδα ρυθμίσεων API του λογαριασμού πωλητή σας στο Kaufland.",
          "PLACEHOLDER": "κλειδί 32 χαρακτήρων",
          "ERROR": "Εισάγετε το Client Key των 32 χαρακτήρων"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Το Secret Key των 64 χαρακτήρων που ανήκει στο Client Key. Το Kaufland το εμφανίζει μία φορά και δεν επιστρέφει ποτέ σε αυτήν τη σελίδα.",
          "PLACEHOLDER": "κλειδί 64 χαρακτήρων",
          "ERROR": "Εισάγετε το Secret Key των 64 χαρακτήρων"
        },
        "SUBMIT_BUTTON": "Δημιουργία Καναλιού Kaufland",
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να αποθηκεύσουμε το κανάλι Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Αποσυνδέθηκε",
          "MESSAGE": "Το Kaufland απέρριψε αυτά τα κλειδιά API. Εισάγετε ξανά το Client Key και το Secret Key για να επανασυνδέσετε αυτό το κιβώτιο."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Κανάλι Email",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα καναλιού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα καναλιού",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Το Email στο οποίο οι πελάτες σας θα στέλνουν αιτήματα υποστήριξης",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Δημιουργία Καναλιού Email",
        "API": {
          "ERROR_MESSAGE": "Δεν είμαστε σε θέση να αποθηκεύσουμε το Email κανάλι"
        },
        "FINISH_MESSAGE": "Προώθηση των email σας στην ακόλουθη διεύθυνση email."
      },
      "LINE_CHANNEL": {
        "TITLE": "Κανάλι LINE",
        "DESC": "Ενσωμάτωση με κανάλι LINE και ξεκινήστε να υποστηρίζετε τους πελάτες σας.",
        "CHANNEL_NAME": {
          "LABEL": "Όνομα καναλιού",
          "PLACEHOLDER": "Παρακαλώ εισάγετε ένα όνομα καναλιού",
          "ERROR": "Το πεδίο είναι απαραίτητο"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID Καναλιού LINE",
          "PLACEHOLDER": "ID Καναλιού LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret Καναλιού LINE",
          "PLACEHOLDER": "Secret Καναλιού LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token Καναλιού LINE",
          "PLACEHOLDER": "Token Καναλιού LINE"
        },
        "SUBMIT_BUTTON": "Δημιουργία LINE Καναλιού",
        "API": {
          "ERROR_MESSAGE": "Δεν είμαστε σε θέση να αποθηκεύσουμε το LINE κανάλι"
        },
        "API_CALLBACK": {
          "TITLE": "URL επανάκλησης",
          "SUBTITLE": "Θα πρέπει να ρυθμίσετε τη διεύθυνση URL webhook στην εφαρμογή LINE με τη διεύθυνση URL που αναφέρεται εδώ."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Κανάλι Telegram",
        "DESC": "Ενσωμάτωση με το κανάλι Telegram και ξεκινήστε να υποστηρίζετε τους πελάτες σας.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Ρυθμίστε το bot token που λάβατε από το BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Δημιουργία Καναλιού Telegram",
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να αποθηκεύσουμε το telegram κανάλι"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Τηλεφωνικές κλήσεις",
        "DESC": "Ρυθμίστε ποιες τηλεφωνικές κλήσεις θα εμφανίζονται σε αυτό το κιβώτιο.",
        "NAME": {
          "LABEL": "Όνομα κιβωτίου",
          "SUBTITLE": "Επιλέξτε ένα εύκολα αναγνωρίσιμο όνομα."
        },
        "PHONE_NUMBER": {
          "LABEL": "Αριθμός τηλεφώνου",
          "SUBTITLE": "Εισάγετε αριθμούς τηλεφώνου που ανήκουν σε αυτό το κιβώτιο, μπορείτε να προσθέσετε περισσότερους αριθμούς αργότερα.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Δημιουργία κιβωτίου Τηλεφωνικών κλήσεων",
        "API": {
          "ERROR_MESSAGE": "Δεν ήμασταν σε θέση να δημιουργήσουμε το κιβώτιο"
        }
      },
      "AUTH": {
        "TITLE": "Επιλογή Καναλιού",
        "DESC": "Το chat υποστηρίζει widget live-chat, σελίδα Facebook, Whatsapp, Email κλπ., ως κανάλια. Αν θέλετε να δημιουργήσετε ένα προσαρμοσμένο κανάλι, μπορείτε να το δημιουργήσετε χρησιμοποιώντας το κανάλι API. Επιλέξτε ένα κανάλι από τις παρακάτω επιλογές για να συνεχίσετε."
      },
      "AGENTS": {
        "TITLE": "Πράκτορες",
        "DESC": "Εδώ μπορείτε να προσθέσετε πράκτορες στο κιβώτιο που μόλις δημιουργήσατε. Μονο αυτοί οι επιλεγμένοι πράκτορες θα έχουν πρόσβαση στο κιβώτιο. Οι πράκτορες που δεν ανήκουν σε αυτο το κιβώτιο δεν θα έχουν την δυνατότητα να ανταποκρίνονται σε μηνήματα αυτού του κιβωτίου όταν κάνουν login στο σύστημα. <br> <b>ΥΓ:</b> Ως Διαχειριστής, αν θέλετε πρόσβαση σε όλα τα κιβώτια, θα πρέπει να προσθέσετε τον εαυτό σας σε όλα τα κιβώτια που δημιουργείτε.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Επιλέξτε πράκτορες για το κιβώτιο"
      },
      "DETAILS": {
        "TITLE": "Λεπτομέρειες Κιβωτίου",
        "DESC": "Από το αναπτυσσόμενο μενού παρακάτω, επιλέξτε τη σελίδα Facebook που θέλετε να συνδέσετε στο chat. Μπορείτε επίσης να δώσετε ένα προσαρμοσμένο όνομα στα εισερχόμενά σας για καλύτερη αναγνώριση."
      },
      "FINISH": {
        "TITLE": "Το καρφώσατε!",
        "DESC": "Ολοκληρώσατε με επιτυχία την ενσωμάτωση της σελίδας σας στο Facebook με το chat. Την επόμενη φορά που ένας πελάτης στέλνει μηνύματα στη σελίδα σας, η συνομιλία θα εμφανιστεί αυτόματα στα εισερχόμενά σας. <br> Σας παρέχουμε επίσης ένα σενάριο widget που μπορείτε εύκολα να προσθέσετε στον ιστότοπό σας. Μόλις δημοσιευτεί ζωντανά στον ιστότοπό σας, οι πελάτες μπορούν να σας στείλουν μηνύματα απευθείας από τον ιστότοπό σας χωρίς τη βοήθεια εξωτερικού εργαλείου και η συνομιλία θα εμφανιστεί εδώ, στο chat. <br> Ωραία, ε; Λοιπόν, σίγουρα προσπαθούμε να είμαστε :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Πιστοποίηση ταυτότητας στο Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Κάτι πήγε στραβά, Παρακαλώ ανανεώστε την σελίδα...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Δεν ήταν δυνατή η δημιουργία του κιβωτίου εισερχομένων. Παρακαλώ προσπαθήστε ξανά.",
      "CREATING_CHANNEL": "Δημιουργία κιβωτίου εισερχομένων...",
      "TITLE": "Διαμόρφωση λεπτομερειών κιβωτίου",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Προσθήκη πρακτόρων",
      "ADD_AGENTS": "Προσθήκη πρακτόρων στο κιβώτιο εισερχομένων..."
    },
    "FINISH": {
      "TITLE": "Το κιβώτιο σας είναι έτοιμο!",
      "MESSAGE": "Μπορείτε να συνομιλείτε με τους πελάτες σας από το νέο κανάλι. Καλή υποστήριξη",
      "BUTTON_TEXT": "Μετάβαση",
      "MORE_SETTINGS": "Περισσότερες ρυθμίσεις",
      "WEBSITE_SUCCESS": "Επιτυχής δημιουργία του καναλιού ιστοσελίδας. Αντιγράψτε τον κώδικα που παρουσιάζεται παρακάτω, και τοποθετήστε τον στην ιστοσελίδα σας. Την επόμενη φορά που κάποιος πελάτης χρησιμοποιήσει το 'live chat', η συνομιλία θα εμφανιστεί στο κιβώτιο εισερχομένων σας."
    },
    "REAUTH": "Εκ νέου εξουσιοδότηση",
    "VIEW": "Προβολή",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Οι ρυθμίσεις του κιβωτίου ενημερώθηκαν",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Η αυτόματη αντιστοίχιση ενημερώθηκε επιτυχώς",
        "ERROR_MESSAGE": "Δεν μπορέσαμε να ενημερώσουμε τις ρυθμίσεις εισερχομένων. Παρακαλώ δοκιμάστε ξανά αργότερα."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "από",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Κανένα"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "ENABLE_HMAC": {
        "LABEL": "Ενεργοποίηση"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Ενεργό",
        "DISABLED": "Ανενεργό"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Ενεργοποίηση συγχρονισμού εισερχόμενων email"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Ενεργοποίηση Προσαρμοσμένου Domain Email (επί πληρωμή υπηρεσία)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Ενεργοποίηση επεξεργασίας σχολίων Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Υπογραφή HTML",
        "SUB_TEXT": "Αυτή η υπογραφή θα προστίθεται στο υποσέλιδο κάθε μηνύματος που στέλνεται από αυτό το κιβώτιο.",
        "HTML_CONTENT": "Κώδικας HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} θα αντικατασταθεί με το όνομα του πράκτορα.\n{'{{'}email{'}}'} θα αντικατασταθεί με τη διεύθυνση email του πράκτορα που έστειλε το email.\n{'{{'}position{'}}'} θα αντικατασταθεί με τη θέση του πράκτορα.\n{'{{'}custom_line{'}}'} θα αντικατασταθεί με την προσαρμοσμένη γραμμή του πράκτορα.\n{'{{'}email_signature_picture{'}}'} θα αντικατασταθεί με το URL της εικόνας υπογραφής email του πράκτορα (όχι με ετικέτα εικόνας) — χρησιμοποιήστε το ως πηγή εικόνας (το src μιας ετικέτας img).",
        "PREVIEW": "Προεπισκόπηση"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Υπογραφές ανά χώρα",
        "SUB_TEXT": "Η απάντηση παίρνει την υπογραφή της χώρας του αγοραστή.",
        "HELP": "Η απάντηση υπογράφεται ανάλογα με τη χώρα της συνομιλίας: το κατάστημα του Kaufland, την αγορά της παραγγελίας του Allegro ή, διαφορετικά, τη γλώσσα στην οποία γράφει ο αγοραστής. Όταν η χώρα είναι άγνωστη ή δεν έχει υπογραφή εδώ, χρησιμοποιείται η υπογραφή HTML παραπάνω. Τα marketplace απαγορεύουν συνδέσμους προς τον ιστότοπό σας και στοιχεία επικοινωνίας, γι' αυτό περιοριστείτε σε έναν χαιρετισμό και {'{{'}name{'}}'}.",
        "EMPTY": "Δεν έχετε ακόμη υπογραφές χωρών, επομένως οι απαντήσεις χρησιμοποιούν την υπογραφή HTML παραπάνω.",
        "COUNTRY": "Επιλέξτε χώρα",
        "ADD": "Προσθήκη υπογραφής χώρας",
        "REMOVE": "Αφαίρεση"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Πρόθεμα Κλήσης Αριθμού Τηλεφώνου",
        "PLACEHOLDER": "Εισάγετε πρόθεμα για σωστή δρομολόγηση κλήσεων (π.χ., *99)",
        "HELP_TEXT": "Αυτό το πρόθεμα θα προστίθεται αυτόματα μπροστά από τους αριθμούς τηλεφώνου επαφών κατά την κλήση από αυτό το κιβώτιο."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Κείμενο κουμπιού «Θα το λύσουμε αργότερα»",
        "PLACEHOLDER": "π.χ. Θα λύσουμε αυτό το θέμα μέσω email. Τώρα θέλω να ρωτήσω για κάτι άλλο.",
        "HELP_TEXT": "Η ετικέτα του κουμπιού του widget που επιτρέπει στον επισκέπτη να αφήσει το τρέχον θέμα και να ρωτήσει για κάτι άλλο. Αφήστε το πεδίο κενό για να χρησιμοποιηθεί το προεπιλεγμένο κείμενο στη γλώσσα του επισκέπτη."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Αυτόματη αναβολή αναπάντητων κλήσεων για X λεπτά",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Αναβάλλει αυτόματα τις αναπάντητες κλήσεις για τον καθορισμένο αριθμό λεπτών. Αφήστε κενό ή 0 για απενεργοποίηση."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Επίλυση αναπάντητης κλήσης μετά από X αποτυχημένες επανακλήσεις",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Όταν μια αναπάντητη κλήση έχει επανακληθεί X φορές χωρίς να απαντήσει ο πελάτης, επιλύεται αυτόματα και προστίθεται ιδιωτική σημείωση. Αφήστε κενό ή 0 για απενεργοποίηση."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Προτάσεις Ερωτήσεων",
        "SUB_TEXT": "Διαμορφώστε προκαθορισμένες ερωτήσεις που οι πελάτες μπορούν να χρησιμοποιήσουν για να αλληλεπιδράσουν με τους πράκτορές σας.",
        "QUESTIONS_LABEL": "Ερωτήσεις",
        "ADD_QUESTION": "Προσθήκη Ερώτησης",
        "REMOVE": "Αφαίρεση",
        "QUESTION_TEXT": "Κείμενο που εμφανίζεται στη φούσκα.",
        "QUESTION_TEXT_PLACEHOLDER": "Υποχρεωτικό",
        "QUESTION_PAYLOAD": "Κείμενο που αποστέλλεται όταν πατηθεί.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Προαιρετικό",
        "NO_BOT_MESSAGE": "Για να δημιουργήσετε επιπλέον προτάσεις AI, παρακαλώ συνδέστε ένα bot.",
        "BOT_CONNECTED_MESSAGE": "Οι προτάσεις ερωτήσεων AI από το bot μπορούν να ενεργοποιηθούν στις",
        "BOT_SETTINGS_LINK": "ρυθμίσεις του"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Εναλλακτικά email",
        "SUB_TEXT": "Πρόσθετες διευθύνσεις που αυτά τα εισερχόμενα πρέπει να αντιμετωπίζουν ως δικές τους κατά τη λήψη προωθημένων μηνυμάτων.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Προσθήκη",
        "REMOVE": "Αφαίρεση",
        "EMPTY": "Δεν έχουν διαμορφωθεί εναλλακτικά email.",
        "HELP_TEXT": "Όταν φτάνει ένα email με μία από αυτές τις διευθύνσεις ως παραλήπτη, οι απαντήσεις θα αποστέλλονται με την ίδια διεύθυνση ως αποστολέα. Βεβαιωθείτε ότι ο εξερχόμενος διακομιστής SMTP σας επιτρέπει την αποστολή από αυτές τις διευθύνσεις.",
        "SIGNATURE_LABEL": "Υπογραφή",
        "PRIMARY_SIGNATURE": "Κύρια (προεπιλογή)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Πρόσθετες υπογραφές",
        "SUB_TEXT": "Ορίστε εδώ επιπλέον υπογραφές και, στη συνέχεια, αντιστοιχίστε τες στα εναλλακτικά email παρακάτω.",
        "OPTION": "Υπογραφή {number}",
        "ADD": "Προσθήκη υπογραφής",
        "REMOVE": "Αφαίρεση",
        "HELP_TEXT": "Όταν μια απάντηση αποστέλλεται από ένα εναλλακτικό email, χρησιμοποιείται η υπογραφή που του έχει αντιστοιχιστεί αντί για την υπογραφή των εισερχομένων. Τα εναλλακτικά email που παραμένουν στο «Κύρια (προεπιλογή)» χρησιμοποιούν την υπογραφή των εισερχομένων."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "AVATAR_DELETE_BUTTON_TEXT": "Διαγραφή Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Αυτό το κιβώτιο έχει σημειωθεί για διαγραφή",
      "RESTORE_BUTTON_TEXT": "Επαναφορά",
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είσαστε σίγουρος για την διαγραφή ",
        "PLACE_HOLDER": "Παρακαλώ πληκτρολογήστε {inboxName} για επιβεβαίωση",
        "YES": "Ναι, Διέγραψε το ",
        "NO": "Όχι, Κράτησε τον/την"
      },
      "API": {
        "SUCCESS_MESSAGE": "Το κιβώτιο διαγράφηκε επιτυχώς",
        "MARKED_FOR_DELETION_MESSAGE": "Το κιβώτιο σημειώθηκε για διαγραφή",
        "RESTORE_SUCCESS_MESSAGE": "Το κιβώτιο επαναφέρθηκε επιτυχώς",
        "ERROR_MESSAGE": "Αδυναμία διαγραφής του κιβωτίου. Παρακαλώ προσπαθήστε αργότερα.",
        "RESTORE_ERROR_MESSAGE": "Δεν ήταν δυνατή η επαναφορά του κιβωτίου. Παρακαλώ προσπαθήστε ξανά αργότερα.",
        "AVATAR_SUCCESS_MESSAGE": "Το avatar εισερχομένων διαγράφηκε επιτυχώς",
        "AVATAR_ERROR_MESSAGE": "Δεν ήταν δυνατή η διαγραφή του avatar εισερχομένων. Παρακαλώ προσπαθήστε ξανά αργότερα."
      }
    },
    "TABS": {
      "SETTINGS": "Ρυθμίσεις",
      "COLLABORATORS": "Συνεργάτες",
      "AUTOMATIC_PRIORITY": "Αυτόματη Προτεραιότητα",
      "AUTOMATIC_LABELING": "Αυτόματη Επισήμανση",
      "CONFIGURATION": "Διαμόρφωση",
      "CAMPAIGN": "Καμπάνιες",
      "PRE_CHAT_FORM": "Φόρμα Προ-Συνομιλίας",
      "BUSINESS_HOURS": "Ώρες Εργασίας",
      "WIDGET_BUILDER": "Δημιουργός Widget",
      "BOT_CONFIGURATION": "Ρυθμίσεις Bot",
      "SLA": "SLA"
    },
    "SETTINGS": "Ρυθμίσεις",
    "FEATURES": {
      "LABEL": "Χαρακτηριστικά",
      "DISPLAY_FILE_PICKER": "Να εμφανίζεται η επιλογή αρχείου στο widget",
      "DISPLAY_EMOJI_PICKER": "Να εμφανίζεται ο επιλογές emoji στο widget",
      "ALLOW_END_CONVERSATION": "Επιτρέψτε στους χρήστες να τερματίσουν τη συνομιλία από το widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Εμφάνιση του κουμπιού «Έναρξη νέας συνομιλίας» στην κεφαλίδα του widget",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Εμφάνιση του κουμπιού «Μεταφορά σε χειριστή» στην κεφαλίδα του widget",
      "AUTO_CLOSE_OLD": "Σήμανση όλων των προηγούμενων κλήσεων από τον ίδιο αριθμό ως επιλυμένων μόλις επιλυθεί μία",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Αυτόματη ανάθεση αναπάντητων κλήσεων κατά την πραγματοποίηση εξερχόμενης κλήσης",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Να επιτρέπεται στους πράκτορες να στέλνουν μηνύματα όταν η επαφή είναι εκτός σύνδεσης και δεν είναι διαθέσιμη η συνέχεια email"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Κώδικας (Script)",
      "MESSENGER_SUB_HEAD": "Τοποθετήσετε αυτόν τον κώδικα μέσα στο body tag της ιστοσελίδας σας",
      "INBOX_AGENTS": "Πράκτορες",
      "INBOX_TEAMS": "Ομάδες",
      "INBOX_COOPERATORS": "Συνεργάτες",
      "SELECT_PLACEHOLDER": "Επιλογή",
      "AGENTS_OR_TEAMS_INFO": "Μπορείτε να αναθέσετε είτε πράκτορες είτε ομάδες - όχι και τα δύο ταυτόχρονα.",
      "INBOX_AGENTS_SUB_TEXT": "Προσθέστε ή αφαιρέστε πράκτορες σε αυτό το κιβώτιο",
      "AGENT_ASSIGNMENT": "Ανάθεση Συνομιλίας",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Ενημέρωση ρυθμίσεων ανάθεσης συνομιλίας",
      "UPDATE": "Ενημέρωση",
      "ENABLE_EMAIL_COLLECT_BOX": "Ενεργοποιήσετε το πλαίσιο συλλογής email",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Ενεργοποίηση ή απενεργοποίηση του πλαισίου συλλογής μηνυμάτων ηλεκτρονικού ταχυδρομείου στη νέα συνομιλία",
      "AUTO_ASSIGNMENT": "Επιτρέπεται η αυτόματη αντιστοίχιση",
      "ENABLE_CSAT": "Ενεργοποίηση CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Ενεργοποίηση CSAT σε κάθε μήνυμα",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Ενεργοποίηση/Απενεργοποίηση της έρευνας CSAT (ικανοποίηση πελατών) μετά την επίλυση μιας συνομιλίας",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Ενεργοποίηση/Απενεργοποίηση της επιλογής έρευνας CSAT για κάθε μήνυμα που στέλνουν οι πράκτορες",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Ενεργοποίηση της συνέχειας συνομιλίας μέσω email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Οι συζητήσεις θα συνεχίσουν μέσω email αν η διεύθυνση ηλεκτρονικού ταχυδρομείου επαφής είναι διαθέσιμη.",
      "RESPOND_FROM_EMAIL": "Απάντηση από email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Τα email προς τον πελάτη — τόσο οι απαντήσεις όσο και τα αντίγραφα συνομιλίας — αποστέλλονται χρησιμοποιώντας τις ρυθμίσεις SMTP του επιλεγμένου κιβωτίου email, από την επιλεγμένη διεύθυνση (την ίδια τη διεύθυνση του κιβωτίου ή ένα από τα ψευδώνυμά του), και οι απαντήσεις του πελάτη επιστρέφουν μέσω της διεύθυνσης IMAP του.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Τα αντίγραφα συνομιλίας αποστέλλονται χρησιμοποιώντας τις ρυθμίσεις SMTP του επιλεγμένου κιβωτίου email, από την επιλεγμένη διεύθυνση (την ίδια τη διεύθυνση του κιβωτίου ή ένα από τα ψευδώνυμά του), με τις απαντήσεις να επιστρέφουν μέσω της διεύθυνσης IMAP του.",
      "SHOW_WELCOME_SCREEN": "Εμφάνιση οθόνης καλωσορίσματος",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Εμφάνιση της οθόνης καλωσορίσματος όταν ανοίγει το widget. Αν είναι απενεργοποιημένο, το widget θα μεταβαίνει απευθείας στην προβολή συνομιλίας.",
      "AUTO_CLOSE_PENDING": "Αυτόματη επίλυση συνομιλιών AI μετά από (ώρες)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Αυτόματη επίλυση συνομιλιών AI μετά από X ώρες αδράνειας.",
      "LOCK_TO_SINGLE_CONVERSATION": "Κλείδωμα σε μία μόνο συζήτηση",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Ενεργοποίηση ή απενεργοποίηση πολλαπλών συνομιλιών για την ίδια επαφή σε αυτά τα εισερχόμενα",
      "INBOX_UPDATE_TITLE": "Ρυθμίσεις Κιβωτίου",
      "INBOX_UPDATE_SUB_TEXT": "Ενημερώστε τις ρυθμίσεις του κιβωτίου σας",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Ενεργοποιήστε ή απενεργοποιήστε την αυτόματη αντιστοίχιση των νέων συζητήσεων στους πράκτορες αυτού του κιβωτίου.",
      "HMAC_VERIFICATION": "Επικύρωση Ταυτότητας Χρήστη",
      "HMAC_DESCRIPTION": "Για λόγους επικύρωσης της ταυτότητας των χρηστών, το SDK σας επιτρέπει να περάσετε ένα `identity_hash` για κάθε χρήστη. Μπορείτε να δημιουργήσετε HMAC χρησιμοποιώντας το 'sha256' με το κλειδί που εμφανίζεται εδώ.",
      "HMAC_ROTATE": {
        "BUTTON": "Εναλλαγή κλειδιού",
        "TITLE": "Εναλλαγή μυστικού κλειδιού;",
        "WARNING": "Το τρέχον κλειδί ανακαλείται αμέσως μόλις το εναλλάξετε.",
        "WARNING_DETAIL": "Δεν υπάρχει περίοδος επικάλυψης και δεν μπορεί να αποκατασταθεί.",
        "IMPACT": "Οι διακομιστές σας πρέπει να υπογράφουν τους χρήστες με το νέο κλειδί. Όποιος εξακολουθεί να είναι υπογεγραμμένος με το παλιό, αποτυγχάνει στην επαλήθευση. Αν απαιτείται επαλήθευση ταυτότητας, δεν μπορεί να ξεκινήσει συνομιλία.",
        "CONFIRM": "Εναλλαγή κλειδιού",
        "CANCEL": "Άκυρο",
        "SUCCESS": "Το μυστικό κλειδί εναλλάχθηκε με επιτυχία",
        "ERROR": "Δεν ήταν δυνατή η εναλλαγή του μυστικού κλειδιού, παρακαλώ προσπαθήστε ξανά"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Επιβολή Επαλήθευσης Ταυτότητας Χρήστη",
      "HMAC_MANDATORY_DESCRIPTION": "Αν ενεργοποιηθεί, τα αιτήματα που χωρίς το `identifier_hash` θα απορριφθούν.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Επιβολή νέας συνομιλίας σε κάθε φόρτωση του Widget",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Εάν είναι ενεργοποιημένο, το άνοιγμα του Widget σε νέα καρτέλα ή παράθυρο ξεκινά μια νέα συνομιλία.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Διαγραφή της επαφής κατά την έναρξη νέας συνομιλίας",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Εάν είναι απενεργοποιημένο, μια νέα συνομιλία που ξεκινά από το widget διατηρεί την προηγούμενη επαφή.",
      "INBOX_IDENTIFIER": "Αναγνωριστικό Εισερχόμενων",
      "INBOX_IDENTIFIER_SUB_TEXT": "Χρησιμοποιήστε το διακριτικό `inbox_identifier` που εμφανίζεται εδώ για τον έλεγχο ταυτότητας των πελατών API.",
      "FORWARD_EMAIL_TITLE": "Προώθηση στο email",
      "FORWARD_EMAIL_SUB_TEXT": "Προώθηση των email σας στην ακόλουθη διεύθυνση email.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Συγχρονισμός Email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Ενεργοποίηση αυτόματου συγχρονισμού και λήψης εισερχόμενων email από αυτό το κιβώτιο",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Προσαρμοσμένο Domain Email",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Ενεργοποιήστε για χρήση προσαρμοσμένου domain email για τα εξερχόμενα email",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Μπορείτε να διαβάσετε περισσότερα εδώ.",
      "FACEBOOK_COMMENTS_TITLE": "Σχόλια Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Επιτρέψτε τα μηνύματα μετά την επίλυση της συνομιλίας",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Επιτρέψτε στους τελικούς χρήστες να στέλνουν μηνύματα ακόμη και μετά την επίλυση της συζήτησης.",
      "WIDGET_STATUS_LABEL": "Κατάσταση Widget",
      "WIDGET_STATUS_ENABLED": "Ενεργό",
      "WIDGET_STATUS_BUSINESS_HOURS": "Ενεργό κατά τις ώρες εργασίας",
      "WIDGET_STATUS_DISABLED": "Ανενεργό",
      "WIDGET_STATUS_HELP_TEXT": "Ελέγξτε πότε εμφανίζεται το widget στους επισκέπτες της ιστοσελίδας σας",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Γλώσσα Έρευνας CSAT και Email",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Επιλέξτε τη γλώσσα για όλα τα email πελατών, συμπεριλαμβανομένων των ερευνών CSAT, των αντιγράφων συνομιλίας και των ειδοποιήσεων email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Κληρονόμηση από τον λογαριασμό",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Σύνδεση WhatsApp",
        "SUBTITLE": "Πώς είναι συνδεδεμένο αυτό το εισερχόμενο με το WhatsApp.",
        "PROVIDER": "Πάροχος",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Συνδέθηκε μέσω της ενσωματωμένης εγγραφής της Meta",
        "STATUS": "Κατάσταση",
        "CONNECTED": "Συνδεδεμένο",
        "RECONNECT_HINT": "Πατήστε Επανασύνδεση στην ειδοποίηση παραπάνω.",
        "PHONE_NUMBER": "Αριθμός τηλεφώνου",
        "BUSINESS_ACCOUNT": "ID λογαριασμού WhatsApp Business",
        "OPEN_MANAGER": "Άνοιγμα στο WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID αριθμού τηλεφώνου",
        "TEMPLATES": "Πρότυπα μηνυμάτων",
        "TEMPLATES_COUNT": "{approved} από {total} εγκεκριμένα",
        "TEMPLATES_SYNCED": "Τελευταίος συγχρονισμός: {date}",
        "TEMPLATES_NOT_SYNCED": "Δεν έχουν συγχρονιστεί ακόμη",
        "MANAGE_TEMPLATES": "Διαχείριση προτύπων"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Αυτόματο όριο ανάθεσης",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Παρακαλώ εισάγετε μια τιμή μεγαλύτερη από 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Περιορισμός του μέγιστου αριθμού συνομιλιών από αυτά τα εισερχόμενα που μπορούν να εκχωρηθούν αυτόματα σε έναν πράκτορα"
    },
    "SLA": {
      "TITLE": "Πολιτικές SLA",
      "SUB_TEXT": "Διαμορφώστε τους χρόνους απόκρισης και επίλυσης SLA για κάθε επίπεδο προτεραιότητας συνομιλίας.",
      "LOADING": "Φόρτωση πολιτικών SLA...",
      "FIELDS": {
        "ACTIVE": "Ενεργή",
        "TICKET_PRIORITY": "Προτεραιότητα αιτήματος",
        "FIRST_RESPONSE_TIME": "Χρόνος πρώτης απόκρισης",
        "EVERY_RESPONSE_TIME": "Χρόνος κάθε απόκρισης",
        "RESOLUTION_TIME": "Χρόνος επίλυσης",
        "PLACEHOLDER": "π.χ. 1ω 30λ"
      },
      "API": {
        "SUCCESS_MESSAGE": "Οι πολιτικές SLA ενημερώθηκαν επιτυχώς.",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η ενημέρωση των πολιτικών SLA. Παρακαλώ προσπαθήστε ξανά."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Αυτόματη Προτεραιότητα",
      "SUB_TEXT": "Διαμορφώστε την αυτόματη ανάθεση προτεραιότητας βάσει του περιεχομένου της συνομιλίας.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Ειδοποίηση Χρέωσης",
        "MESSAGE": "Κάθε αξιολόγηση προτεραιότητας επιφέρει χρέωση. Παρακαλώ ελέγξτε τις λεπτομέρειες του προγράμματός σας για πληροφορίες τιμολόγησης."
      },
      "MODE": {
        "OFF": "Ανενεργό",
        "ALL_MESSAGES": "Ενεργό για όλα τα εισερχόμενα μηνύματα",
        "FIRST_MESSAGE": "Ενεργό μόνο για το πρώτο εισερχόμενο μήνυμα"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Διαμόρφωση Επιπέδου Προτεραιότητας",
        "SUB_TEXT": "Διαμορφώστε ποια επίπεδα προτεραιότητας θα είναι ενεργά και τις περιγραφές τους. Δώστε σαφή κριτήρια ώστε η AI να καθορίζει πότε πρέπει να ανατεθεί αυτή η προτεραιότητα."
      },
      "DESCRIPTION_LABEL": "Περιγραφή",
      "DESCRIPTION_PLACEHOLDER": "Περιγράψτε τις συνομιλίες που θα σημειώνονται με προτεραιότητα {priority}",
      "SET_AS_DEFAULT": "Ορισμός ως προεπιλεγμένη προτεραιότητα",
      "MULTIPLE_DEFAULTS_WARNING": "Μόνο ένα επίπεδο προτεραιότητας πρέπει να οριστεί ως προεπιλογή. Παρακαλώ αποεπιλέξτε τις άλλες προεπιλογές."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Αυτόματη Επισήμανση",
      "SUB_TEXT": "Διαμορφώστε την αυτόματη ανάθεση ετικετών βάσει του περιεχομένου της συνομιλίας.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Ειδοποίηση Χρέωσης",
        "MESSAGE": "Κάθε αξιολόγηση επισήμανσης επιφέρει χρέωση. Παρακαλώ ελέγξτε τις λεπτομέρειες του προγράμματός σας για πληροφορίες τιμολόγησης."
      },
      "MODE": {
        "OFF": "Ανενεργό",
        "CONVERSATION_OPEN": "Κατά το άνοιγμα συνομιλίας",
        "CONVERSATION_CLOSE": "Κατά το κλείσιμο συνομιλίας",
        "ALL_MESSAGES": "Σε κάθε μήνυμα - ανεξαρτήτως κατάστασης",
        "FIRST_MESSAGE": "Στο πρώτο μήνυμα - ανεξαρτήτως κατάστασης"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Διαμόρφωση Ετικέτας",
        "SUB_TEXT": "Διαμορφώστε ποιες ετικέτες θα είναι διαθέσιμες για αυτόματη ανάθεση και τις περιγραφές τους. Δώστε σαφή κριτήρια ώστε η AI να καθορίζει πότε πρέπει να εφαρμοστεί αυτή η ετικέτα."
      },
      "DESCRIPTION_LABEL": "Περιγραφή",
      "DESCRIPTION_PLACEHOLDER": "Περιγράψτε τις συνομιλίες που θα επισημαίνονται ως {label}. Αν το αφήσετε κενό, θα χρησιμοποιηθεί η περιγραφή της ετικέτας.",
      "NO_LABELS_MESSAGE": "Δεν βρέθηκαν ετικέτες. Δημιουργήστε πρώτα ετικέτες για να ενεργοποιήσετε την αυτόματη επισήμανση.",
      "CREATE_LABELS_LINK": "Δημιουργία ετικετών"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Εκ νέου εξουσιοδότηση",
      "SUBTITLE": "Η σύνδεση Facebook έχει λήξει, παρακαλώ ξανασυνδεθείτε στο Facebook για να συνεχίσετε",
      "MESSAGE_SUCCESS": "Επιτυχής επανασύνδεση",
      "MESSAGE_ERROR": "Υπήρξε ένα σφάλμα, παρακαλώ προσπαθήστε ξανά"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Οι προ-φόρμες συνομιλίας σας επιτρέπουν να συλλέξετε πληροφορίες για τον χρήστη πριν να ξεκινήσει τη συνομιλία μαζί σας.",
      "SET_FIELDS": "Πεδία προ συνομιλίας",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Πεδία",
        "LABEL": "Ετικέτα",
        "PLACE_HOLDER": "Τοποθέτηση",
        "KEY": "Κλειδί",
        "TYPE": "Τύπος",
        "REQUIRED": "Υποχρεωτικό"
      },
      "ENABLE": {
        "LABEL": "Ενεργοποίηση προ-φόρμας συνομιλίας",
        "OPTIONS": {
          "ENABLED": "Ναι",
          "DISABLED": "Όχι"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Μήνυμα πριν την συνομιλία",
        "PLACEHOLDER": "Αυτό το μήνυμα θα εμφανίζεται στους χρήστες μαζί με τη φόρμα"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Οι επισκέπτες θα πρέπει να συμπληρώνουν το όνομα και τη διεύθυνση ηλεκτρονικού ταχυδρομείου τους πριν από την έναρξη της συνομιλίας"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Ορίστε τη διαθεσιμότητά σας",
      "SUBTITLE": "Ορίστε τη διαθεσιμότητα στο livechat widget σας",
      "WEEKLY_TITLE": "Ορίστε τις εβδομαδιαίες ώρες σας",
      "TIMEZONE_LABEL": "Επιλέξτε ζώνη ώρας",
      "UPDATE": "Ενημέρωση ρυθμίσεων ωραρίου",
      "TOGGLE_AVAILABILITY": "Ενεργοποίηση διαθεσιμότητας ωραρίου για αυτό το κιβώτιο εισερχομένων",
      "UNAVAILABLE_MESSAGE_LABEL": "Μήνυμα μη διαθεσιμότητας για τους επισκέπτες",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Ενεργοποιήσετε τη διαθεσιμότητα για αυτήν την ημέρα",
        "UNAVAILABLE": "Μη διαθέσιμος",
        "HOURS": "ώρες",
        "VALIDATION_ERROR": "Ο χρόνος έναρξης πρέπει να είναι πριν το χρόνο λήξης.",
        "CHOOSE": "Επιλέξτε"
      },
      "ALL_DAY": "Όλη Την Ημέρα",
      "SAVE_TO_ALL": "Αποθήκευση σε Όλα τα Κιβώτια",
      "SAVE_TO_ALL_TITLE": "Αντιγραφή Ωρών Εργασίας",
      "SAVE_TO_ALL_CONFIRM": "Οι ρυθμίσεις από αυτή τη φόρμα (εναλλαγή διαθεσιμότητας, μήνυμα εκτός γραφείου, ζώνη ώρας και ώρες εργασίας) θα αντιγραφούν σε όλα τα άλλα κιβώτια, εκτός από τα κιβώτια email και τηλεφώνου. Είστε σίγουροι ότι θέλετε να συνεχίσετε;",
      "SAVE_TO_ALL_CANCEL": "Άκυρο",
      "SAVE_TO_ALL_YES": "Ναι, Αντιγραφή σε Όλα",
      "SAVE_TO_ALL_SUCCESS": "Οι ώρες εργασίας αντιγράφηκαν σε όλα τα άλλα κιβώτια επιτυχώς",
      "SAVE_TO_ALL_ERROR": "Αποτυχία αντιγραφής ωρών εργασίας στα άλλα κιβώτια"
    },
    "PHONE": {
      "TITLE": "Ρυθμίσεις τηλεφώνου",
      "SUBTITLE": "Διαμορφώστε ποιες κλήσεις θα εμφανίζονται σε αυτό το κιβώτιο.",
      "UPDATE": "Αποθήκευση ρυθμίσεων",
      "EDIT": {
        "SUCCESS_MESSAGE": "Οι ρυθμίσεις τηλεφώνου ενημερώθηκαν"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Αριθμοί τηλεφώνου",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Ορισμός λεπτομερειών IMAP",
      "NOTE_TEXT": "Για να ενεργοποιήσετε το SMTP, παρακαλώ ρυθμίστε το IMAP.",
      "UPDATE": "Ενημέρωση ρυθμίσεων IMAP",
      "TOGGLE_AVAILABILITY": "Ενεργοποίηση ρυθμίσεων IMAP για αυτά τα εισερχόμενα",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Οι ρυθμίσεις IMAP ενημερώθηκαν επιτυχώς",
        "ERROR_MESSAGE": "Αδυναμία ενημέρωσης των ρυθμίσεων IMAP"
      },
      "ADDRESS": {
        "LABEL": "Διεύθυνση",
        "PLACE_HOLDER": "Διεύθυνση (π.χ: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Θύρα",
        "PLACE_HOLDER": "Θύρα"
      },
      "LOGIN": {
        "LABEL": "Είσοδος",
        "PLACE_HOLDER": "Είσοδος"
      },
      "PASSWORD": {
        "LABEL": "Κωδικός",
        "PLACE_HOLDER": "Κωδικός"
      },
      "ENABLE_SSL": "Ενεργοποίηση SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Ορισμός λεπτομερειών SMTP",
      "UPDATE": "Ενημέρωση ρυθμίσεων SMTP",
      "TOGGLE_AVAILABILITY": "Ενεργοποίηση ρυθμίσεων SMTP για αυτά τα εισερχόμενα",
      "TOGGLE_HELP": "Η ενεργοποίηση του SMTP θα βοηθήσει τον χρήστη να στείλει email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Οι ρυθμίσεις SMTP ενημερώθηκαν επιτυχώς",
        "ERROR_MESSAGE": "Αδυναμία ενημέρωσης των ρυθμίσεων SMTP"
      },
      "ADDRESS": {
        "LABEL": "Διεύθυνση",
        "PLACE_HOLDER": "Διεύθυνση (π.χ: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Θύρα",
        "PLACE_HOLDER": "Θύρα"
      },
      "LOGIN": {
        "LABEL": "Είσοδος",
        "PLACE_HOLDER": "Είσοδος"
      },
      "PASSWORD": {
        "LABEL": "Κωδικός",
        "PLACE_HOLDER": "Κωδικός"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Κρυπτογράφηση",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Λειτουργία Επιβεβαίωσης SSL",
      "AUTH_MECHANISM": "Πιστοποίηση"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Παράδοση email (DNS)",
      "SUB_TITLE": "Ελέγχουμε τις εγγραφές SPF, DKIM, DMARC και MX του {domain} κάθε εργάσιμη ημέρα. Όταν κάτι κάνει τους διακομιστές παραλαβής να απορρίπτουν ή να στέλνουν στα ανεπιθύμητα τις απαντήσεις σας, οι διαχειριστές λαμβάνουν email με τη διόρθωση.",
      "RUN": "Εκτέλεση ελέγχου",
      "RUN_SUCCESS": "Ο έλεγχος DNS ολοκληρώθηκε",
      "RUN_ERROR": "Δεν ήταν δυνατή η εκτέλεση του ελέγχου DNS, δοκιμάστε ξανά",
      "NOT_CHECKED": "Δεν έχει ελεγχθεί ακόμη.",
      "CHECKED_AT": "Τελευταίος έλεγχος {time}.",
      "DNS_UNAVAILABLE": "Ο τελευταίος έλεγχος δεν έλαβε απάντηση από τους διακομιστές ονομάτων του domain. Το παρακάτω αποτέλεσμα προέρχεται από τον προηγούμενο έλεγχο.",
      "SENDER": {
        "SMTP": "Οι απαντήσεις αποστέλλονται μέσω του {host}.",
        "PLATFORM": "Οι απαντήσεις αποστέλλονται μέσω των διακομιστών αλληλογραφίας μας."
      },
      "STATUS": {
        "OK": "Όλες οι εγγραφές είναι σε σειρά",
        "WARNING": "Ορισμένες εγγραφές θα μπορούσαν να είναι καλύτερες",
        "ERROR": "Οι απαντήσεις μπορεί να μην φτάνουν στους παραλήπτες",
        "UNKNOWN": "Άγνωστο"
      },
      "SEVERITY": {
        "ERROR": "Πρόβλημα",
        "WARNING": "Προειδοποίηση"
      },
      "FIX": "Διορθώστε το με αυτή την εγγραφή DNS:",
      "RECORD_TYPE": "Τύπος",
      "RECORD_HOST": "Όνομα",
      "RECORD_VALUE": "Τιμή",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Λείπει η εγγραφή SPF",
          "DESCRIPTION": "Το domain δεν δηλώνει ποιοι διακομιστές μπορούν να στέλνουν email για λογαριασμό του. Πολλοί διακομιστές αλληλογραφίας τότε θεωρούν τις απαντήσεις σας ανεπιθύμητες. Προσθέστε μια εγγραφή SPF που επιτρέπει το {sender}."
        },
        "spf_multiple": {
          "TITLE": "Το domain έχει {count} εγγραφές SPF",
          "DESCRIPTION": "Ένα domain επιτρέπεται να έχει μόνο μία εγγραφή SPF. Αν υπάρχουν περισσότερες, οι διακομιστές παραλαβής αγνοούν το SPF και συχνά απορρίπτουν το μήνυμα. Συγχωνεύστε τες σε μία εγγραφή."
        },
        "spf_not_authorized": {
          "TITLE": "Το SPF δεν επιτρέπει τον διακομιστή που στέλνει τις απαντήσεις σας",
          "DESCRIPTION": "Οι απαντήσεις σας αποστέλλονται μέσω του {sender}, αλλά η εγγραφή SPF του domain δεν το περιλαμβάνει. Τρέχουσα εγγραφή: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Η εγγραφή SPF απαιτεί πάρα πολλές αναζητήσεις DNS",
          "DESCRIPTION": "Οι διακομιστές παραλαβής σταματούν τον έλεγχο SPF μετά από {limit} αναζητήσεις DNS, αλλά το {sender}, που στέλνει τις απαντήσεις σας, εντοπίζεται μόλις μετά από {lookups}. Οι απαντήσεις σας αποτυγχάνουν στον έλεγχο SPF. Μετακινήστε το {sender} στην αρχή της εγγραφής και αφαιρέστε τα include που το domain δεν χρησιμοποιεί πια."
        },
        "spf_lookups_others": {
          "TITLE": "Ορισμένοι αποστολείς στην εγγραφή SPF βρίσκονται πέρα από το όριο αναζητήσεων",
          "DESCRIPTION": "Η εγγραφή SPF απαιτεί {lookups} αναζητήσεις DNS, ενώ οι διακομιστές παραλαβής σταματούν μετά από {limit}. Οι απαντήσεις σας αντιστοιχίζονται εγκαίρως και περνούν τον έλεγχο, αλλά τα μηνύματα από αυτούς τους αποστολείς αποτυγχάνουν στο SPF: {senders}. Αφαιρέστε τα include που το domain δεν χρησιμοποιεί πια."
        },
        "spf_malformed": {
          "TITLE": "Η εγγραφή SPF είναι εσφαλμένη",
          "DESCRIPTION": "Οι διακομιστές παραλαβής δεν μπορούν να διαβάσουν την εγγραφή SPF του domain, οπότε δεν προστατεύει τις απαντήσεις σας. Το πρόβλημα βρίσκεται στο: {terms}. Αντικαταστήστε την εγγραφή με τη διορθωμένη."
        },
        "dkim_missing": {
          "TITLE": "Η υπογραφή DKIM δεν έχει ρυθμιστεί",
          "DESCRIPTION": "Δεν βρήκαμε κλειδί DKIM στο {selectors}. Χωρίς αυτό οι απαντήσεις σας δεν υπογράφονται και είναι πιο πιθανό να καταλήξουν στα ανεπιθύμητα. Ενεργοποιήστε την υπογραφή DKIM για το domain μέσω του παρόχου email σας."
        },
        "dmarc_missing": {
          "TITLE": "Λείπει η εγγραφή DMARC",
          "DESCRIPTION": "Μεγάλοι πάροχοι email, όπως το Gmail και το Microsoft, αναμένουν μια εγγραφή DMARC. Χωρίς αυτήν οι απαντήσεις σας είναι πιο πιθανό να καταλήξουν στα ανεπιθύμητα."
        },
        "dmarc_fails": {
          "TITLE": "Το DMARC ζητά από τους παραλήπτες να απορρίπτουν τις απαντήσεις σας",
          "DESCRIPTION": "Η πολιτική DMARC του domain είναι «{policy}» και οι απαντήσεις σας δεν περνούν ούτε τον έλεγχο SPF ούτε τον DKIM, οπότε οι παραλήπτες τις απορρίπτουν ή τις στέλνουν στα ανεπιθύμητα. Διορθώστε πρώτα τα SPF και DKIM παραπάνω."
        },
        "dmarc_blocks_platform": {
          "TITLE": "Το DMARC μπλοκάρει τις απαντήσεις που στέλνονται μέσω των διακομιστών μας",
          "DESCRIPTION": "Αυτό το εισερχόμενο στέλνει απαντήσεις μέσω των διακομιστών αλληλογραφίας μας, αλλά η πολιτική DMARC του domain είναι «{policy}», οπότε οι παραλήπτες τις απορρίπτουν ή τις στέλνουν στα ανεπιθύμητα. Ρυθμίστε για αυτό το εισερχόμενο το SMTP του δικού σας διακομιστή αλληλογραφίας."
        },
        "mx_missing": {
          "TITLE": "Το domain δεν έχει εγγραφή MX",
          "DESCRIPTION": "Χωρίς εγγραφή MX κανείς δεν μπορεί να στείλει email στο domain, οπότε οι πελάτες δεν μπορούν να απαντήσουν στις απαντήσεις σας."
        }
      }
    },
    "NOTE": "Σημείωση: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar Ιστοσελίδας",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Το Avatar διαγράφηκε επιτυχώς",
              "ERROR_MESSAGE": "Υπήρξε ένα σφάλμα, παρακαλώ προσπαθήστε ξανά"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Όνομα Ιστοσελίδας",
          "PLACE_HOLDER": "Συμπληρώστε την ονομασία της ιστοσελίδας σας (π.χ: Ελληνικό Μεσογειακό Πανεπιστήμιο)",
          "ERROR": "Παρακαλώ δώστε ένα έγκυρο όνομα ιστοσελίδας"
        },
        "WELCOME_HEADING": {
          "LABEL": "Καλώς ήλθατε (Heading)",
          "PLACE_HOLDER": "Γεια χαρά!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Καλώς ήλθατε (Tagline)",
          "PLACE_HOLDER": "Είναι απλό να συνδεθείτε μαζί μας. Ζητήστε μας οτιδήποτε, ή μοιραστείτε την εμπειρία σας."
        },
        "REPLY_TIME": {
          "LABEL": "Χρόνος Απάντησης",
          "IN_A_FEW_MINUTES": "Σε μερικά λεπτά",
          "IN_A_FEW_HOURS": "Σε μερικές ώρες",
          "IN_A_DAY": "Σε μία ημέρα"
        },
        "WIDGET_COLOR_LABEL": "Χρώμα Widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Θέση Φυσαλίδας Widget",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Μέγιστο ύψος μη αναγνωσμένων μηνυμάτων (px)",
          "PLACE_HOLDER": "Χωρίς όριο",
          "HELP_TEXT": "Περιορίστε το μέγιστο ύψος του παραθύρου μη αναγνωσμένων μηνυμάτων σε pixel. Αφήστε το κενό για την προεπιλεγμένη συμπεριφορά (χωρίς όριο)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Τύπος Φυσαλίδας Widget",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Συνομιλήστε μαζί μας",
          "LABEL": "Τίτλος Εκκίνησης Φυσαλίδας Widget",
          "PLACE_HOLDER": "Συνομιλήστε μαζί μας"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Ενημέρωση Ρυθμίσεων Widget",
          "API": {
            "SUCCESS_MESSAGE": "Οι ρυθμίσεις widget ενημερώθηκαν με επιτυχία",
            "ERROR_MESSAGE": "Δεν είναι δυνατή η ενημέρωση ρυθμίσεων widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Προεπισκόπηση",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Αριστερά",
          "RIGHT": "Δεξιά"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Εκτεταμένη Φυσαλίδα"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Προεπιλογή",
        "CHAT": "Συνομιλία"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Τυπικά έχετε απάντηση σε μερικά λεπτά",
        "IN_A_FEW_HOURS": "Τυπικά έχετε απάντηση σε μερικές σε μερικές ώρες",
        "IN_A_DAY": "Τυπικά έχετε απάντηση σε μία ημέρα"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Έναρξη Συνομιλίας",
        "CHAT_INPUT_PLACEHOLDER": "Πληκτρολογήστε το μήνυμά σας"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Είμαστε online",
          "OFFLINE": "Προς το παρόν, είμαστε εκτός"
        },
        "USER_MESSAGE": "Γειά",
        "AGENT_MESSAGE": "Γειά σας"
      },
      "BRANDING_TEXT": "με την δύναμη του JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Ιστότοπος",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "Email",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Κανάλι API",
      "PHONE": "Τηλέφωνο SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
